import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { gql, useQuery } from "@apollo/client";

export const DYNAMIC_CMP_PERMISSION_QUERY = gql`
  query DynamicCmpPermissionQuery ($organisationId: ID!, $permission: String!) {
    hasPermission(organisationId: $organisationId, permission: $permission)
  }
`;

export default function useDynamicCmpPermission({ permission }) {
  const { organisationId } = useOrganisationContext();

  const { data, loading } = useQuery(DYNAMIC_CMP_PERMISSION_QUERY, {
    variables: {
      organisationId,
      permission
    },
    fetchPolicy: "network-only",
    skip: !organisationId
  });

  if (loading) return null;
  return data?.hasPermission ?? false;
}
